import type { SessionInfo } from '../schemas/session-info';

type SplitSessions = {
  readonly devices: readonly SessionInfo[];
  readonly delegated: readonly SessionInfo[];
};

/** Own devices (this one first) and delegated agents (most recently used first). */
export function splitSessions(sessions: readonly SessionInfo[]): SplitSessions {
  const byUse = [...sessions].sort(
    (a, b) => Number(b.current) - Number(a.current) || b.last_seen_at.localeCompare(a.last_seen_at),
  );
  return {
    devices: byUse.filter((session) => session.kind === 'device'),
    delegated: byUse.filter((session) => session.kind === 'delegated'),
  };
}
